import supportMeritsConfig from 'wwg-utilities/dist/config/supportMeritsConfig';
import project from './project';
const supportMeritsIconMapping = supportMeritsConfig[project].supportMeritsIconsMapping;
export default supportMeritsIconMapping;

